import type { BillingProcess } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

export async function fetchBillingProcesses(): Promise<BillingProcess[]> {
  const response = await Client.get<BillingProcess[]>({
    endpoint: '/billing/processes',
  });
  return response.data;
}
